import { BASE_URL } from '@/config'

export async function getCybersecurityConcepts() {
  try {
    const response = await fetch(`${BASE_URL}/graphs/cybersecurity-concept/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar conceitos de cibersegurança'
      )
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Erro ao buscar conceitos de cibersegurança:', error)
    throw error
  }
}

export async function getCybersecurityConceptsByIdEnterprise(enterpriseId) {
  // console.log(
  //   'ID da empresa getCybersecurityConceptsByIdEnterprise:',
  //   enterpriseId
  // )
  try {
    const response = await fetch(
      `${BASE_URL}/graphs/cybersecurity/enterprise/${enterpriseId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message ||
          'Erro ao buscar conceitos de cibersegurança da empresa'
      )
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error(
      'Erro ao buscar conceitos de cibersegurança da empresa:',
      error
    )
    throw error
  }
}
